import { Tooltip as MUITooltip, TooltipProps } from '@mui/material';

const Tooltip = (props: TooltipProps) => {
  return <MUITooltip {...props} />;
};

export default Tooltip;
